module.exports = __webpack_public_path__ + "static/media/arrow-results.6549e814.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dublin-express/arrow-results.svg
// module id = 275
// module chunks = 0